import _ from 'lodash';
import { withProps } from 'recompose';
import { SubmissionError } from 'redux-form';

const mapErrors = errors => _.mapValues(errors, error => _.head(error));
const defaultDataMapper = data => data;
const defaultOptions = { dataMapper: defaultDataMapper };

const FormErrorsHandlerHOC = ({
  dataMapper = defaultDataMapper,
} = defaultOptions) => WrappedComponent => withProps(
  ({ submitAction, onSuccess }) => ({
    onSubmit: data => submitAction(dataMapper(data))
      .then((result) => {
        if (result.error) {
          switch (result.payload.status) {
            case 422:
              throw new SubmissionError({
                ...mapErrors(result.payload.response.errors),
                _error: result.payload.message,
              });
            case 500:
              throw new SubmissionError({
                confirmation: 'Не все поля заполнены/код не уникальный',
                _error: result.payload.message,
              });
            case 401:
              throw new SubmissionError({
                confirmation: 'Неверный код подтверждения',
                _error: result.payload.message,
              });
            default:
              throw new SubmissionError({ _error: result.payload.message });
          }
        }

        if (_.isFunction(onSuccess)) {
          onSuccess(result);
        }
      }),
  }),
)(WrappedComponent);

export default FormErrorsHandlerHOC;



// WEBPACK FOOTER //
// ./src/components/HOCs/FormErrorsHandlerHOC/index.js